import { render, staticRenderFns } from "./StyleProvider.vue?vue&type=template&id=cc3aba46"
import script from "./StyleProvider.vue?vue&type=script&lang=js"
export * from "./StyleProvider.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./StyleProvider.vue?vue&type=style&index=0&id=cc3aba46&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports